import { DoughnutChartLabels } from '@/components/charts/DoughnutChart/DoughnutChartLabels';
import { Stack } from '@mui/material';
import { merge } from 'lodash';
import React from 'react';
export const DoughnutChartLegend = ({ chartRef, containerProps }) => {
    if (!chartRef.current) {
        return null;
    }
    const chart = chartRef.current.data || {};
    //const labels = chart.datasets || []
    const defaultContainerProps = merge({
        direction: 'row',
        sx: {
            flexWrap: 'wrap',
        },
    }, containerProps);
    const getBackgroundColor = (chart, idx) => {
        const { datasets } = chart;
        const [currDataSet] = datasets || [];
        if (currDataSet) {
            return currDataSet.backgroundColor[idx];
        }
        return '';
    };
    const getAmount = (chart, idx) => {
        const { datasets } = chart;
        const [currDataSet] = datasets || [];
        if (currDataSet) {
            return currDataSet.data[idx];
        }
        return '';
    };
    return (React.createElement(Stack, { ...defaultContainerProps }, chart.labels &&
        chart.labels.map((label, idx) => (React.createElement(DoughnutChartLabels, { key: label, label: label, color: getBackgroundColor(chart, idx), amount: getAmount(chart, idx) })))));
};
